'use strict';

const angular = require('angular');

import { AdminBasketUtil } from './adminBasketUtil';
import { ISeason, IPrice, ISeasonUtilsService, IMembership } from '../../interfaces';

class Extra {
  extraRef: any;
  selected: boolean;
  quantity: number;
  totalPrice: number;
  
  constructor(extraRef, selected, quantity, totalPrice) {
    this.extraRef = extraRef;
    this.selected = selected;
    this.quantity = quantity;
    this.totalPrice = totalPrice;
  }
}

export class adminBasketEditComponent{
  $http: ng.IHttpService;
  SeasonUtils: ISeasonUtilsService
  AdminBasketUtil: AdminBasketUtil = new AdminBasketUtil();
  
  season: ISeason;
  basket: any;
  
  searchMemberString: string;
  members: IMembership[];
  memberSelected: IMembership;
  
  extraEmail: String;
  extraEmailSubmitted = false;
  
  submitted;
  editMode = false;
  extrasSelected: any[] = [];
  extraTotal: number = 0;

  newPriceSelected: IPrice = null;

  /*ngInjector*/
  constructor($http, SeasonUtils: ISeasonUtilsService) {
    this.$http = $http;
    this.SeasonUtils = SeasonUtils;
  }

  $onInit() {
    let resolve = (this as any).resolve;
     
    // Get the season parameter
    if (_.has(resolve, 'season') && resolve.season !== null) {
      this.season = resolve.season;
    } else {
      this.cancel();
    }

    // Get the basket parameter
    if (_.has(resolve, 'basket') && resolve.basket !== null) {
      this.editMode = true;
      this.basket = _.cloneDeep(resolve.basket);
      this.basket.numPaymentsExpected = this.basket.numPaymentsExpected.toString();
      this.newPriceSelected = this.basket.newPrice;

    } else {
      this.basket = {};
      this.basket.price = null;
      this.basket.numPaymentsExpected = "1";
      this.basket.payments = [];
      this.basket.extraEmails = [];
      this.updateDeadlines("1");
      this.newPriceSelected = null;
    }

    //Reset Extras
    this.season.availableExtras.forEach(availableExtra => {
      if (this.editMode) {
        let extraQuantity = this.basket.extras.find(e => {
          if (e.extra && e.extra._id) {
            return e.extra._id === availableExtra._id
          }
          return false;
        });
        if (extraQuantity) {
          this.extrasSelected.push( new Extra(availableExtra, true, extraQuantity.quantity, extraQuantity.totalPrice));
        } else {
          this.extrasSelected.push( new Extra(availableExtra, false, 0, 0));  
        }

      } else {
        this.extrasSelected.push( new Extra(availableExtra, false, 0, 0));
      }
    });

    //Reset submit form
    this.submitted = false;
  }

  /**
   * 
   */
  updateSearch() {
    let scope = this;
    if (this.searchMemberString && this.searchMemberString.length>2) {
      this.$http.post("/api/memberships/find", {query: this.searchMemberString})
        .then(res => {
          scope.members = res.data as IMembership[];
        });
    } else {
      scope.members = [];
    }
  }
  
  /**
   * Save temporary of the pickup option selected
   * @param pickupOption 
   */
  selectPickupOption(pickupOption: any) {
    //this.pickupOptionSelected = pickupOption;
    this.basket.defaultPickupOption = pickupOption;
  }

  /**
   * Get baskets of the current season for member passed by parameter
   * @param member
   */
  getMemberBaskets(member) {
    if (member.baskets && member.baskets.length>0) {
      return member.baskets.filter(basket => basket.season === this.season._id);
    }
    return [];
  }

  selectMember(member) {
    this.basket.membership = member;
  }

  setNewPrice(newPrice) {
    this.newPriceSelected = newPrice;
  }

  updateExtra(extra) {
    if (extra.selected) {
      extra.totalPrice = extra.quantity * extra.extraRef.price;
    } else {
      extra.totalPrice = 0;
      extra.quantity = 0;
    }
  }

  isExtraSelected() {
    return this.extrasSelected.length>0 && this.extrasSelected.filter( extraSelected => extraSelected.selected && extraSelected.quantity>0 ).length > 0;
  }

  getTotalPrice() {
    let basketPrice = this.getBasketPrice();
    let extraPrice  = this.getExtraTotal();
    return this.AdminBasketUtil.parseToFloatTwoDecimal(Number(basketPrice) + Number(extraPrice));
  }

  getBasketPrice() {
    let basketPrice = 0;

    if (this.basket.price !== null && this.basket.price !== '') {
      basketPrice = this.basket.price;
    } else if (this.newPriceSelected) {
      basketPrice = this.newPriceSelected.price;
    }
    
    return this.AdminBasketUtil.parseToFloatTwoDecimal(basketPrice);
  }

  getExtraTotal() {
    let extrasTotalPrice = 0;
    for(let extra of this.extrasSelected) {
      if (extra.selected && extra.quantity>0) {
        extrasTotalPrice += extra.totalPrice;
      }
    }
    return this.AdminBasketUtil.parseToFloatTwoDecimal(extrasTotalPrice);
  }

  updateDeadlines(value) {
    let deadlines: Date[] = this.SeasonUtils.getDeadlinesForNumberOfPayments(this.season, this.basket.numPaymentsExpected);
    
    this.basket.payments = [];
    for (let deadline of deadlines) {
      this.basket.payments.push({date: deadline, amount: 0});
    }
  }

  /**
   * Save basket for the current membership.
   * Extras has to be transformed
   * @param basket 
   */
  create(form) {
    this.submitted = true;

    if(form.$valid) {
      let price = this.AdminBasketUtil.parseToFloatTwoDecimal(this.basket.price);
      let fixedPrice = this.newPriceSelected;

      // Price could not be null
      if (price == null && fixedPrice == null) {
        price = '0';
      }

      this.$http.post("/api/baskets/", 
        {membership: this.basket.membership._id, 
          season: this.season, 
          defaultPickupOption: this.basket.defaultPickupOption._id, 
          extras: this.extrasSelected
            .filter(extraSelected => extraSelected.selected && extraSelected.quantity>0)
            .map(extraSelected => ({
              extra:extraSelected.extraRef, 
              quantity: extraSelected.quantity, 
              totalPrice: this.AdminBasketUtil.parseToFloatTwoDecimal(extraSelected.totalPrice)
            })),
          price: price,
          newPrice: fixedPrice, 
          enable: this.basket.enable,
          numPaymentsExpected: this.basket.numPaymentsExpected,
          payments: this.basket.payments,
          extraEmails: this.basket.extraEmails,
          creationDate: new Date()
        })
      .then(res => {
        this.basket = res.data;
        this.ok();
      });
    }
  }

  save(form) {
    this.submitted = true;
    this.extraEmailSubmitted = false;

    if (form.$valid) {
      let candidate = _.cloneDeep(this.basket);
      delete candidate.__v; //This field is managed automatically

      if (this.extrasSelected && this.extrasSelected.length>0) {
        candidate.price = this.AdminBasketUtil.parseToFloatTwoDecimal(candidate.price);
        candidate.newPrice = this.newPriceSelected;
        candidate.extras = this.extrasSelected
          .filter(extraSelected => extraSelected.selected && extraSelected.quantity>0)
          .map(extraSelected => ({
            extra:extraSelected.extraRef, 
            quantity: extraSelected.quantity, 
            totalPrice: this.AdminBasketUtil.parseToFloatTwoDecimal(extraSelected.totalPrice)
          }));
      }
      
      this.$http.put("/api/baskets/"+this.basket._id, candidate)
      .then(res => {
        this.basket = res.data;
        this.ok();
      });
    }
  }

  addExtraEmail(extraEmailInput) {
    this.extraEmailSubmitted = true;

    if ( this.basket.extraEmails.length < 3 && extraEmailInput.$valid ) {
    // if ( this.basket.extraEmails.length < 3 ) {
      // this.extraEmailSubmitted = true;
      this.basket.extraEmails.push(this.extraEmail);
      this.extraEmail = '';
      this.extraEmailSubmitted = false;
    }
  }

  removeExtraEmail(email) {
    var index = this.basket.extraEmails.indexOf(email);
    this.basket.extraEmails.splice( index, 1 );
  }
  
  ok() {
    (this as any).close({$value: this.basket});
  };

  cancel() {
    (this as any).dismiss({$value: 'cancel'});
  };

}

export default angular.module('terrappApp.adminBaskets')
  .component('adminBasketEdit', {
    template: require('./adminBasketEdit.html'),
    controller: adminBasketEditComponent,
    controllerAs: '$ctrl',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
  }).name;


// WEBPACK FOOTER //
// ./client/app/admin/adminBaskets/adminBasketEdit.component.ts